import React from "react";
import { Box } from "@mui/material";

const PageWrapper = ({ children }) => (
  <Box
    sx={{
      mt: 3,
      border: 0,
      padding: {
        xs: "0px",
        md: "20px 10px",
      },
    }}
  >
    {children}
  </Box>
);

export default PageWrapper;
